// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Inicio — operator deck. Foco del día, KPI strip, agenda de 5 días hábiles,
   feed de actuaciones del PJUD. The app shell (sidebar + topbar) lives outside;
   this owns the .page content grid. Loaded only on the dashboard, so the
   .card/.tbl helpers here are local and don't collide with the page-scoped
   versions on other screens. */

/* ---------- FOCO DEL DÍA ---------- */
.focus {
  border: 1px solid var(--rule);
  background: var(--paper-elev);
  padding: 18px 20px 20px;
  margin-bottom: var(--s-6);
}
.focus__head {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 14px;
}
.focus__count {
  font-family: var(--mono);
  font-size: var(--fs-figure);
  color: var(--ink-3);
  margin-left: auto;
  font-variant-numeric: tabular-nums;
}
.focus__grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 12px;
}
.focus-card {
  background: var(--surface);
  border: 1px solid var(--rule);
  padding: 14px 15px;
  display: flex;
  flex-direction: column;
  gap: 10px;
  cursor: pointer;
  text-align: left;
  font: inherit;
  color: inherit;
  transition:
    border-color var(--dur-1) var(--ease),
    transform var(--dur-1) var(--ease);
}
.focus-card:hover {
  border-color: var(--ink-3);
  transform: translateY(-2px);
}
.focus-card__top {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
}
.focus-card__what {
  font-size: var(--fs-detail);
  line-height: 1.45;
  color: var(--ink);
  margin: 0;
  flex: 1;
}
.focus-card__foot {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  border-top: 1px solid var(--rule-soft);
  padding-top: 10px;
}
.focus-card__cta {
  font-size: var(--fs-meta);
  color: var(--accent);
  display: inline-flex;
  align-items: center;
  gap: 5px;
  white-space: nowrap;
}

/* ---------- KPI STRIP ---------- */
.kpi-strip {
  display: grid;
  grid-template-columns: 1.6fr repeat(4, 1fr);
  gap: 12px;
  margin-bottom: var(--s-6);
}
.kpi {
  position: relative;
  border: 1px solid var(--rule);
  background: var(--surface);
  padding: 20px;
  display: flex;
  flex-direction: column;
  gap: 8px;
}
.kpi__label {
  font-family: var(--mono);
  font-size: var(--fs-eyebrow);
  letter-spacing: 0.14em;
  text-transform: uppercase;
  color: var(--ink-3);
}
.kpi__value {
  font-family: var(--display);
  font-weight: 300;
  letter-spacing: -0.035em;
  line-height: 1;
  color: var(--ink);
  font-variant-numeric: tabular-nums;
  font-size: var(--fs-kpi);
}
.kpi__value--sm {
  font-size: 32px;
}
.kpi--hero {
  gap: 6px;
}
.kpi__hero-row {
  display: flex;
  align-items: flex-start;
  gap: 12px;
}
.kpi__hero-meta {
  margin-top: 10px;
  line-height: 1.35;
}
.kpi__delta {
  margin-top: auto;
}
.kpi--link {
  cursor: pointer;
  text-align: left;
  font: inherit;
  transition:
    border-color var(--dur-1) var(--ease),
    transform var(--dur-1) var(--ease);
}
.kpi--link:hover {
  border-color: var(--ink-3);
}
/* Hint sits at the bottom of the card (reflowed, not overlapping the label);
   its line height is always reserved so the tile height is stable, and it
   fades in on hover. */
.kpi__hint {
  margin-top: auto;
  padding-top: 12px;
  font-family: var(--mono);
  font-size: var(--fs-micro);
  letter-spacing: 0.04em;
  color: var(--accent);
  opacity: 0;
  transition: opacity var(--dur-1) var(--ease);
  white-space: nowrap;
}
.kpi--link:hover .kpi__hint {
  opacity: 1;
}

/* ---------- TWO-COLUMN LOWER GRID ---------- */
.dash-cols {
  display: grid;
  grid-template-columns: 1.9fr 1fr;
  gap: var(--s-6);
  align-items: start;
}

/* Without the feed (role without org:read-dashboard) the agenda takes the row */
.dash-cols--single {
  grid-template-columns: 1fr;
}

/* local card surface */
.dash-cols .card,
.dash-card {
  border: 1px solid var(--rule);
  background: var(--surface);
}
.dash-card__head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 13px 16px;
  border-bottom: 1px solid var(--rule-soft);
}
.dash-card__title {
  font-family: var(--sans);
  font-size: var(--fs-note);
  font-weight: 500;
  color: var(--ink);
}
.dash-card__link {
  font-size: var(--fs-meta);
  color: var(--accent);
  display: inline-flex;
  align-items: center;
  gap: 5px;
  cursor: pointer;
  white-space: nowrap;
  background: none;
  border: 0;
  font-family: inherit;
}

/* ---------- AGENDA (5 días hábiles) ---------- */
.agenda {
  display: grid;
  grid-template-columns: repeat(5, 1fr);
}
.agenda__day {
  border-right: 1px solid var(--rule-soft);
  padding: 14px 12px;
  min-height: 200px;
}
.agenda__day:last-child {
  border-right: 0;
}
.agenda__day--hot {
  background: var(--paper-elev);
}
.agenda__date {
  display: flex;
  align-items: baseline;
  gap: 7px;
  margin-bottom: 12px;
}
.agenda__dow {
  font-family: var(--mono);
  font-size: var(--fs-nano);
  letter-spacing: 0.14em;
  color: var(--ink-3);
}
.agenda__dd {
  font-family: var(--display);
  font-weight: 300;
  font-size: var(--fs-h2);
  line-height: 1;
  letter-spacing: -0.02em;
  color: var(--ink);
  font-variant-numeric: tabular-nums;
}
.agenda__n {
  font-size: var(--fs-micro);
  color: var(--ink-3);
  margin-left: auto;
  align-self: flex-start;
}
.agenda__items {
  display: flex;
  flex-direction: column;
  gap: 8px;
}
.agenda__empty {
  padding-top: 4px;
  font-size: var(--fs-micro);
  letter-spacing: 0.1em;
  text-transform: uppercase;
  color: var(--ink-3);
  opacity: 0.55;
}
.agenda__item {
  display: flex;
  gap: 8px;
  cursor: pointer;
  text-align: left;
  background: none;
  border: 0;
  padding: 0;
  font: inherit;
  color: inherit;
}
.agenda__item:hover .agenda__what {
  color: var(--accent);
}
.agenda__bar {
  width: 3px;
  flex: none;
  background: var(--ink-3);
}
.agenda__bar--err {
  background: var(--err);
}
.agenda__bar--warn {
  background: var(--warn);
}
.agenda__bar--info {
  background: var(--accent);
}
.agenda__what {
  font-size: var(--fs-2xs);
  line-height: 1.3;
  color: var(--ink);
  margin-bottom: 3px;
}

/* ---------- ACTUACIONES FEED (tabla PJUD) ---------- */
.dash-feed {
  width: 100%;
  border-collapse: collapse;
  font-size: var(--fs-ui);
}
.dash-feed td {
  padding: 10px 16px;
  border-bottom: 1px solid var(--rule-soft);
  vertical-align: top;
}
.dash-feed tbody tr:last-child td {
  border-bottom: 0;
}
.dash-feed tbody tr {
  cursor: pointer;
  transition: background var(--dur-1) var(--ease);
}
.dash-feed tbody tr:hover {
  background: var(--paper-elev);
}
.dash-feed__id {
  font-family: var(--mono);
  font-size: var(--fs-meta);
  color: var(--ink-3);
  white-space: nowrap;
}
.dash-feed__primary {
  color: var(--ink);
}
.dash-feed__secondary {
  font-size: var(--fs-meta);
  color: var(--ink-3);
  margin-top: 2px;
}
.dash-feed__date {
  font-family: var(--mono);
  font-size: var(--fs-meta);
  color: var(--ink-3);
  white-space: nowrap;
  text-align: right;
}
.unread-dot {
  display: inline-block;
  width: 6px;
  height: 6px;
  border-radius: 999px;
  background: var(--accent);
  margin-right: 7px;
  vertical-align: middle;
}
.dash-feed__skel {
  display: block;
  height: 11px;
  border-radius: 2px;
  background: linear-gradient(
    90deg,
    var(--rule-soft) 25%,
    var(--rule) 37%,
    var(--rule-soft) 63%
  );
  background-size: 400% 100%;
  animation: dash-skel 1.2s ease infinite;
}
@keyframes dash-skel {
  0% {
    background-position: 100% 50%;
  }
  100% {
    background-position: 0 50%;
  }
}
.dash-feed__empty,
.dash-feed__error {
  padding: 22px 16px;
  text-align: center;
}
.dash-feed__empty-t,
.dash-feed__error-t {
  color: var(--ink);
  font-size: var(--fs-ui);
}
.dash-feed__error-t {
  color: var(--err);
}

/* ---------- RESPONSIVE ---------- */
@media (max-width: 1100px) {
  .kpi-strip {
    grid-template-columns: 1fr 1fr 1fr;
  }
  .kpi--hero {
    grid-column: 1 / -1;
  }
  .focus__grid {
    grid-template-columns: 1fr;
  }
}
@media (max-width: 1000px) {
  .dash-cols {
    grid-template-columns: 1fr;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/dashboard/DashboardView.css"],"names":[],"mappings":"AAAA;;;;+BAI+B;;AAE/B,uCAAuC;AACvC;EACE,6BAA6B;EAC7B,6BAA6B;EAC7B,uBAAuB;EACvB,yBAAyB;AAC3B;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;AACrB;AACA;EACE,wBAAwB;EACxB,2BAA2B;EAC3B,mBAAmB;EACnB,iBAAiB;EACjB,kCAAkC;AACpC;AACA;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;AACX;AACA;EACE,0BAA0B;EAC1B,6BAA6B;EAC7B,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,cAAc;EACd;;sCAEoC;AACtC;AACA;EACE,0BAA0B;EAC1B,2BAA2B;AAC7B;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;AACX;AACA;EACE,2BAA2B;EAC3B,iBAAiB;EACjB,iBAAiB;EACjB,SAAS;EACT,OAAO;AACT;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,QAAQ;EACR,sCAAsC;EACtC,iBAAiB;AACnB;AACA;EACE,yBAAyB;EACzB,oBAAoB;EACpB,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,mBAAmB;AACrB;;AAEA,oCAAoC;AACpC;EACE,aAAa;EACb,2CAA2C;EAC3C,SAAS;EACT,yBAAyB;AAC3B;AACA;EACE,kBAAkB;EAClB,6BAA6B;EAC7B,0BAA0B;EAC1B,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;AACA;EACE,wBAAwB;EACxB,4BAA4B;EAC5B,sBAAsB;EACtB,yBAAyB;EACzB,mBAAmB;AACrB;AACA;EACE,2BAA2B;EAC3B,gBAAgB;EAChB,wBAAwB;EACxB,cAAc;EACd,iBAAiB;EACjB,kCAAkC;EAClC,wBAAwB;AAC1B;AACA;EACE,eAAe;AACjB;AACA;EACE,QAAQ;AACV;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;AACX;AACA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb;;sCAEoC;AACtC;AACA;EACE,0BAA0B;AAC5B;AACA;;uBAEuB;AACvB;EACE,gBAAgB;EAChB,iBAAiB;EACjB,wBAAwB;EACxB,0BAA0B;EAC1B,sBAAsB;EACtB,oBAAoB;EACpB,UAAU;EACV,4CAA4C;EAC5C,mBAAmB;AACrB;AACA;EACE,UAAU;AACZ;;AAEA,gDAAgD;AAChD;EACE,aAAa;EACb,gCAAgC;EAChC,eAAe;EACf,kBAAkB;AACpB;;AAEA,gFAAgF;AAChF;EACE,0BAA0B;AAC5B;;AAEA,uBAAuB;AACvB;;EAEE,6BAA6B;EAC7B,0BAA0B;AAC5B;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,kBAAkB;EAClB,yCAAyC;AAC3C;AACA;EACE,wBAAwB;EACxB,yBAAyB;EACzB,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,yBAAyB;EACzB,oBAAoB;EACpB,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,mBAAmB;EACnB,gBAAgB;EAChB,SAAS;EACT,oBAAoB;AACtB;;AAEA,kDAAkD;AAClD;EACE,aAAa;EACb,qCAAqC;AACvC;AACA;EACE,wCAAwC;EACxC,kBAAkB;EAClB,iBAAiB;AACnB;AACA;EACE,eAAe;AACjB;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,aAAa;EACb,qBAAqB;EACrB,QAAQ;EACR,mBAAmB;AACrB;AACA;EACE,wBAAwB;EACxB,yBAAyB;EACzB,sBAAsB;EACtB,mBAAmB;AACrB;AACA;EACE,2BAA2B;EAC3B,gBAAgB;EAChB,uBAAuB;EACvB,cAAc;EACd,uBAAuB;EACvB,iBAAiB;EACjB,kCAAkC;AACpC;AACA;EACE,0BAA0B;EAC1B,mBAAmB;EACnB,iBAAiB;EACjB,sBAAsB;AACxB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;AACA;EACE,gBAAgB;EAChB,0BAA0B;EAC1B,qBAAqB;EACrB,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;AACf;AACA;EACE,aAAa;EACb,QAAQ;EACR,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,SAAS;EACT,UAAU;EACV,aAAa;EACb,cAAc;AAChB;AACA;EACE,oBAAoB;AACtB;AACA;EACE,UAAU;EACV,UAAU;EACV,wBAAwB;AAC1B;AACA;EACE,sBAAsB;AACxB;AACA;EACE,uBAAuB;AACzB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,wBAAwB;EACxB,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA,wDAAwD;AACxD;EACE,WAAW;EACX,yBAAyB;EACzB,uBAAuB;AACzB;AACA;EACE,kBAAkB;EAClB,yCAAyC;EACzC,mBAAmB;AACrB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,+CAA+C;AACjD;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,wBAAwB;EACxB,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;AACrB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,eAAe;AACjB;AACA;EACE,wBAAwB;EACxB,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;EACnB,iBAAiB;AACnB;AACA;EACE,qBAAqB;EACrB,UAAU;EACV,WAAW;EACX,oBAAoB;EACpB,yBAAyB;EACzB,iBAAiB;EACjB,sBAAsB;AACxB;AACA;EACE,cAAc;EACd,YAAY;EACZ,kBAAkB;EAClB;;;;;GAKC;EACD,0BAA0B;EAC1B,uCAAuC;AACzC;AACA;EACE;IACE,6BAA6B;EAC/B;EACA;IACE,0BAA0B;EAC5B;AACF;AACA;;EAEE,kBAAkB;EAClB,kBAAkB;AACpB;AACA;;EAEE,iBAAiB;EACjB,uBAAuB;AACzB;AACA;EACE,iBAAiB;AACnB;;AAEA,qCAAqC;AACrC;EACE;IACE,kCAAkC;EACpC;EACA;IACE,mBAAmB;EACrB;EACA;IACE,0BAA0B;EAC5B;AACF;AACA;EACE;IACE,0BAA0B;EAC5B;AACF","sourcesContent":["/* Inicio — operator deck. Foco del día, KPI strip, agenda de 5 días hábiles,\n   feed de actuaciones del PJUD. The app shell (sidebar + topbar) lives outside;\n   this owns the .page content grid. Loaded only on the dashboard, so the\n   .card/.tbl helpers here are local and don't collide with the page-scoped\n   versions on other screens. */\n\n/* ---------- FOCO DEL DÍA ---------- */\n.focus {\n  border: 1px solid var(--rule);\n  background: var(--paper-elev);\n  padding: 18px 20px 20px;\n  margin-bottom: var(--s-6);\n}\n.focus__head {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  margin-bottom: 14px;\n}\n.focus__count {\n  font-family: var(--mono);\n  font-size: var(--fs-figure);\n  color: var(--ink-3);\n  margin-left: auto;\n  font-variant-numeric: tabular-nums;\n}\n.focus__grid {\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  gap: 12px;\n}\n.focus-card {\n  background: var(--surface);\n  border: 1px solid var(--rule);\n  padding: 14px 15px;\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  cursor: pointer;\n  text-align: left;\n  font: inherit;\n  color: inherit;\n  transition:\n    border-color var(--dur-1) var(--ease),\n    transform var(--dur-1) var(--ease);\n}\n.focus-card:hover {\n  border-color: var(--ink-3);\n  transform: translateY(-2px);\n}\n.focus-card__top {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 10px;\n}\n.focus-card__what {\n  font-size: var(--fs-detail);\n  line-height: 1.45;\n  color: var(--ink);\n  margin: 0;\n  flex: 1;\n}\n.focus-card__foot {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 8px;\n  border-top: 1px solid var(--rule-soft);\n  padding-top: 10px;\n}\n.focus-card__cta {\n  font-size: var(--fs-meta);\n  color: var(--accent);\n  display: inline-flex;\n  align-items: center;\n  gap: 5px;\n  white-space: nowrap;\n}\n\n/* ---------- KPI STRIP ---------- */\n.kpi-strip {\n  display: grid;\n  grid-template-columns: 1.6fr repeat(4, 1fr);\n  gap: 12px;\n  margin-bottom: var(--s-6);\n}\n.kpi {\n  position: relative;\n  border: 1px solid var(--rule);\n  background: var(--surface);\n  padding: 20px;\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n.kpi__label {\n  font-family: var(--mono);\n  font-size: var(--fs-eyebrow);\n  letter-spacing: 0.14em;\n  text-transform: uppercase;\n  color: var(--ink-3);\n}\n.kpi__value {\n  font-family: var(--display);\n  font-weight: 300;\n  letter-spacing: -0.035em;\n  line-height: 1;\n  color: var(--ink);\n  font-variant-numeric: tabular-nums;\n  font-size: var(--fs-kpi);\n}\n.kpi__value--sm {\n  font-size: 32px;\n}\n.kpi--hero {\n  gap: 6px;\n}\n.kpi__hero-row {\n  display: flex;\n  align-items: flex-start;\n  gap: 12px;\n}\n.kpi__hero-meta {\n  margin-top: 10px;\n  line-height: 1.35;\n}\n.kpi__delta {\n  margin-top: auto;\n}\n.kpi--link {\n  cursor: pointer;\n  text-align: left;\n  font: inherit;\n  transition:\n    border-color var(--dur-1) var(--ease),\n    transform var(--dur-1) var(--ease);\n}\n.kpi--link:hover {\n  border-color: var(--ink-3);\n}\n/* Hint sits at the bottom of the card (reflowed, not overlapping the label);\n   its line height is always reserved so the tile height is stable, and it\n   fades in on hover. */\n.kpi__hint {\n  margin-top: auto;\n  padding-top: 12px;\n  font-family: var(--mono);\n  font-size: var(--fs-micro);\n  letter-spacing: 0.04em;\n  color: var(--accent);\n  opacity: 0;\n  transition: opacity var(--dur-1) var(--ease);\n  white-space: nowrap;\n}\n.kpi--link:hover .kpi__hint {\n  opacity: 1;\n}\n\n/* ---------- TWO-COLUMN LOWER GRID ---------- */\n.dash-cols {\n  display: grid;\n  grid-template-columns: 1.9fr 1fr;\n  gap: var(--s-6);\n  align-items: start;\n}\n\n/* Without the feed (role without org:read-dashboard) the agenda takes the row */\n.dash-cols--single {\n  grid-template-columns: 1fr;\n}\n\n/* local card surface */\n.dash-cols .card,\n.dash-card {\n  border: 1px solid var(--rule);\n  background: var(--surface);\n}\n.dash-card__head {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  padding: 13px 16px;\n  border-bottom: 1px solid var(--rule-soft);\n}\n.dash-card__title {\n  font-family: var(--sans);\n  font-size: var(--fs-note);\n  font-weight: 500;\n  color: var(--ink);\n}\n.dash-card__link {\n  font-size: var(--fs-meta);\n  color: var(--accent);\n  display: inline-flex;\n  align-items: center;\n  gap: 5px;\n  cursor: pointer;\n  white-space: nowrap;\n  background: none;\n  border: 0;\n  font-family: inherit;\n}\n\n/* ---------- AGENDA (5 días hábiles) ---------- */\n.agenda {\n  display: grid;\n  grid-template-columns: repeat(5, 1fr);\n}\n.agenda__day {\n  border-right: 1px solid var(--rule-soft);\n  padding: 14px 12px;\n  min-height: 200px;\n}\n.agenda__day:last-child {\n  border-right: 0;\n}\n.agenda__day--hot {\n  background: var(--paper-elev);\n}\n.agenda__date {\n  display: flex;\n  align-items: baseline;\n  gap: 7px;\n  margin-bottom: 12px;\n}\n.agenda__dow {\n  font-family: var(--mono);\n  font-size: var(--fs-nano);\n  letter-spacing: 0.14em;\n  color: var(--ink-3);\n}\n.agenda__dd {\n  font-family: var(--display);\n  font-weight: 300;\n  font-size: var(--fs-h2);\n  line-height: 1;\n  letter-spacing: -0.02em;\n  color: var(--ink);\n  font-variant-numeric: tabular-nums;\n}\n.agenda__n {\n  font-size: var(--fs-micro);\n  color: var(--ink-3);\n  margin-left: auto;\n  align-self: flex-start;\n}\n.agenda__items {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n.agenda__empty {\n  padding-top: 4px;\n  font-size: var(--fs-micro);\n  letter-spacing: 0.1em;\n  text-transform: uppercase;\n  color: var(--ink-3);\n  opacity: 0.55;\n}\n.agenda__item {\n  display: flex;\n  gap: 8px;\n  cursor: pointer;\n  text-align: left;\n  background: none;\n  border: 0;\n  padding: 0;\n  font: inherit;\n  color: inherit;\n}\n.agenda__item:hover .agenda__what {\n  color: var(--accent);\n}\n.agenda__bar {\n  width: 3px;\n  flex: none;\n  background: var(--ink-3);\n}\n.agenda__bar--err {\n  background: var(--err);\n}\n.agenda__bar--warn {\n  background: var(--warn);\n}\n.agenda__bar--info {\n  background: var(--accent);\n}\n.agenda__what {\n  font-size: var(--fs-2xs);\n  line-height: 1.3;\n  color: var(--ink);\n  margin-bottom: 3px;\n}\n\n/* ---------- ACTUACIONES FEED (tabla PJUD) ---------- */\n.dash-feed {\n  width: 100%;\n  border-collapse: collapse;\n  font-size: var(--fs-ui);\n}\n.dash-feed td {\n  padding: 10px 16px;\n  border-bottom: 1px solid var(--rule-soft);\n  vertical-align: top;\n}\n.dash-feed tbody tr:last-child td {\n  border-bottom: 0;\n}\n.dash-feed tbody tr {\n  cursor: pointer;\n  transition: background var(--dur-1) var(--ease);\n}\n.dash-feed tbody tr:hover {\n  background: var(--paper-elev);\n}\n.dash-feed__id {\n  font-family: var(--mono);\n  font-size: var(--fs-meta);\n  color: var(--ink-3);\n  white-space: nowrap;\n}\n.dash-feed__primary {\n  color: var(--ink);\n}\n.dash-feed__secondary {\n  font-size: var(--fs-meta);\n  color: var(--ink-3);\n  margin-top: 2px;\n}\n.dash-feed__date {\n  font-family: var(--mono);\n  font-size: var(--fs-meta);\n  color: var(--ink-3);\n  white-space: nowrap;\n  text-align: right;\n}\n.unread-dot {\n  display: inline-block;\n  width: 6px;\n  height: 6px;\n  border-radius: 999px;\n  background: var(--accent);\n  margin-right: 7px;\n  vertical-align: middle;\n}\n.dash-feed__skel {\n  display: block;\n  height: 11px;\n  border-radius: 2px;\n  background: linear-gradient(\n    90deg,\n    var(--rule-soft) 25%,\n    var(--rule) 37%,\n    var(--rule-soft) 63%\n  );\n  background-size: 400% 100%;\n  animation: dash-skel 1.2s ease infinite;\n}\n@keyframes dash-skel {\n  0% {\n    background-position: 100% 50%;\n  }\n  100% {\n    background-position: 0 50%;\n  }\n}\n.dash-feed__empty,\n.dash-feed__error {\n  padding: 22px 16px;\n  text-align: center;\n}\n.dash-feed__empty-t,\n.dash-feed__error-t {\n  color: var(--ink);\n  font-size: var(--fs-ui);\n}\n.dash-feed__error-t {\n  color: var(--err);\n}\n\n/* ---------- RESPONSIVE ---------- */\n@media (max-width: 1100px) {\n  .kpi-strip {\n    grid-template-columns: 1fr 1fr 1fr;\n  }\n  .kpi--hero {\n    grid-column: 1 / -1;\n  }\n  .focus__grid {\n    grid-template-columns: 1fr;\n  }\n}\n@media (max-width: 1000px) {\n  .dash-cols {\n    grid-template-columns: 1fr;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
